import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";

import { TextInput } from "@components/Input";
import { OnboardingLayoutProps } from "@components/OnboardingLayout";
import { Spacing, SpacingSizes } from "@components/Spacing";
import { EntryStepLayout as OnboardingLayout } from "@entry/EntryStepLayout";
import { Translations, i18n } from "@i18n";
import { constants } from "@layout";
import { validationSchema } from "./content";
import { useGoalNameScreenFlow } from "./flow";
import { GoalNameFormValues } from "./types";

export const GoalNameRoute = () => {
  const { handleSubmit, loading } = useGoalNameScreenFlow();

  const {
    register,
    setValue,
    watch,
    handleSubmit: handleFormSubmit,
    formState: { errors, isValid },
  } = useForm<GoalNameFormValues>({
    defaultValues: {
      goalName: "",
    },
    mode: "all",
    resolver: yupResolver(validationSchema),
  });

  const goalNameController = register("goalName");

  const props: OnboardingLayoutProps = {
    title: i18n.t(Translations.GoalNameRouteTitle),
    cta: {
      primary: {
        title: i18n.t(Translations.GoalNameRoutePrimaryCTA),
        onClick: handleFormSubmit(handleSubmit),
        loading,
        disabled: !isValid,
      },
    },
  };

  return (
    <OnboardingLayout {...props}>
      <TextInput
        {...goalNameController}
        label={i18n.t(Translations.GoalNameRouteInputLabel)}
        placeholder={i18n.t(Translations.GoalNameRouteInputPlaceholder)}
        value={watch("goalName")}
        onChangeText={(value) => setValue("goalName", value, constants.form)}
        error={errors.goalName?.message}
      />
      <Spacing size={SpacingSizes.M} />
    </OnboardingLayout>
  );
};
